<template>
  <div>
    <!-- Dialog'u açan buton -->


    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="1200px" persistent>
      <v-card >
        <v-toolbar dark color="primary">

          <v-toolbar-title> Seçim Ekranı</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>
        <!-- <v-card-title class="headline">
          Seçim Ekranı
        </v-card-title> -->

        <v-card-text>
          <!-- Unvan seçimi için autocomplete -->
          <v-container>
            <v-row>
              <v-col>
                <v-radio-group v-model="selectedTur" row>
                  <template v-slot:label>
                    <div>Seçim Türü Seçiniz</div>
                  </template>
                  <v-radio v-for="n in list" :key="n.id" :label="n.name" :value="n.id"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-toolbar dark color="primary">

                  <v-toolbar-title> Seçilenler</v-toolbar-title>
                  <v-spacer></v-spacer>

                </v-toolbar>
                <v-list dense height="400" style="overflow-y: scroll;">
                  <v-text-field v-model="txtItem" append-outer-icon="mdi-plus" @click:append-outer="itemAdd"
                    label="Seçenek Ekle" dense></v-text-field>

                  <v-list-item v-for="(item, index) in selected" :key="item">
                    <!-- <v-list-item-icon>
            <v-icon v-text=""></v-icon>
          </v-list-item-icon> -->
                    <v-list-item-content>
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>


                      <v-icon @click="removeItem(index)" color="yellow darken-3">
                        mdi-delete
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>

                </v-list>
                <!-- <ul class="ulCls">
                  <li class="list-item" v-for="(item,index) in selected" :key="item">{{ item }}
                    <hr role="separator" aria-orientation="horizontal" file="v-divider/usage" class="v-divider theme--light">
                      <button @click="removeItem(index)">Sil</button>
</li>
                </ul> -->
              </v-col>
              <v-col cols="8">
                <component ref="cmpFilter" v-bind:is="selectedTur" @selectedChange="selectedChangeEvent" :onlyNameSurname="true">
                </component>
              </v-col>
            </v-row>
          </v-container>



        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">İptal</v-btn>
          <v-btn color="primary" text @click="saveSelected">Kaydet</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BirimComboSelect from './BirimComboSelect.vue';
import UserSelect from './UserSelect.vue';
import UnvanComboSelect from './UnvanComboSelect.vue';
import IthalItemSelect from './IthalItemSelect.vue';
import ApiItemSelect from './ApiItemSelect.vue';
export default {
  components: {
    BirimComboSelect,
    UnvanComboSelect,
    UserSelect,
    IthalItemSelect,
    ApiItemSelect
  },
  props: {
    show: {
      // default: '{"title":"","description":""}',
      default() {
        return false;
      },
      type: Boolean
    }
  },
  data() {

    return {
      txtItem: "",
      dialog: false,
      selectedTur: "UnvanComboSelect",
      selectedTitle: null,
      list: [
        { id: 'UnvanComboSelect', name: 'Ünvan' },
        { id: 'BirimComboSelect', name: 'Birim' },
        { id: 'UserSelect', name: 'Kullanıcı' },
        { id: 'IthalItemSelect', name: 'Toplu İthal Veri Seçimi' },
        { id: 'ApiItemSelect', name: 'Api İthal Veri Seçimi' },
        // {id:'',name:'OBS Birim'},
        // {id:'',name:'Personel Seçimi'},
        // {id:'',name:'Öğrenci Seçimi'}
      ],
      radioGroup: "OgrUnit",

      selected: []
    };
  },
  watch: {
    show(newValue, oldValue) {
      this.dialog = newValue;
      // isActive değiştiğinde yapılacak işlemler burada
    },


  },
  methods: {
    itemAdd() {
      if (this.txtItem) {
        this.selected.push(this.txtItem);
        this.txtItem = "";
      }
      else {
        this.$toast.warning("Lütfen boşluk eklemeyiniz!");

      }

    },
    removeItem(index) {
      this.selected.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.$emit("close");
    },
    selectedChangeEvent(value) {
      console.log("selectedChangeEvent", value);
      value.forEach(element => {
        if (!this.selected.includes(element)) {
          this.selected.push(element);
        }
      });
      //this.selected=value;
    },
    saveSelected() {
      this.close();
      // Seçilen unvanı burada kullanabilirsiniz
      // let value = this.$refs.cmpFilter.getValue();
      // console.log("Seçilen unvan:", value);
      // Örneğin parent component'e emit edebilirsiniz
      this.$emit("selectedClick", this.selected);
    },
    setSelected(secilenler) {
      this.selected = secilenler;
    }
  }
};
</script>
<style scoped>
.ulCls {
  list-style: none;
  padding: 0px;
  margin: 0px;
  font-family: arial;
  color: black;

  min-height: 350px;
  max-height: 650px;
  overflow-y: scroll;
}

.ulCls li {
  margin: 2px;
}
</style>